import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { CorpException } from '../../../model/src/lib/corp-exception.model';

@Injectable({
  providedIn: 'root'
})
export class CorpExceptionManager {

  mapToCorpException(error: any): CorpException {
    if (error instanceof HttpErrorResponse) {
      return new CorpException({
        userMessage: this.getUserFriendlyMessage(error.status),
        userCode: error.status.toString(),
        technicalMessage: error.message,
        statusCode: error.status,
        originalError: error
      });
    }

    return new CorpException({
      userMessage: 'Une erreur inattendue est survenue.',
      technicalMessage: error?.message ?? String(error),
      originalError: error
    });
  }

  private getUserFriendlyMessage(status: number): string {
    switch (status) {
      case 400:
        return 'Requête invalide.';
      case 401:
        return 'Non autorisé.';
      case 403:
        return 'Accès refusé.';
      case 404:
        return 'Ressource introuvable.';
      case 500:
        return 'Erreur serveur. Veuillez réessayer plus tard.';
      default:
        return 'Une erreur est survenue.';
    }
  }
}